import React, { useState } from 'react';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import ReportBills from './ReportBills';
import { DropDownBoxClient } from '../../components/dropdown/ClienteDropDown';


const BillsByClient = () => {

    const [clientId, setClientId] = useState(0);
 
    const title="Reporte por clientes";

    const onValueChanged = id => {
        setClientId(id);
    } 
    
    return (
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} />

            <label>Seleccione el cliente</label>
            <DropDownBoxClient value= {clientId} onValueChanged={onValueChanged} />
            <div className="mt-10">
                <ReportBills name="Facturas"  params={{clientId}} />
            </div>

        </div>
    );
}

export default BillsByClient;
